package com.vidaensupalabra.vsp.utils

import kotlinx.browser.window

// Llama a la función global definida en nuestro index.html
fun installPwa(): Boolean = js("window.installPwa ? (window.installPwa(), true) : false")

// Llama a la función global definida en nuestro index.html para interactuar con Firebase
fun solicitarPermisoNotificaciones(): Unit = js("window.solicitarPermisoNotificaciones ? window.solicitarPermisoNotificaciones() : undefined")

// Verifica el estado de los permisos de notificación usando JS
fun getNotificationPermissionStatus(): String = js("""
    (function() {
        if (!('Notification' in window)) return 'unsupported';
        return Notification.permission;
    })()
""")

fun reloadApp() {
    window.location.reload()
}